import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
firebase.initializeApp({
  apiKey: "AIzaSyA_8ZcbG333wFR-Pn1dsYqqrjG3QISXkoM",
  authDomain: "bitstarter1.firebaseapp.com",
  projectId: "bitstarter1",
  storageBucket: "bitstarter1.appspot.com",
  messagingSenderId: "439119190374",
  appId: "1:439119190374:web:42f20080989d63130890a7",
  measurementId: "G-KBVKLD5GQE",
});
const db = firebase.firestore();
const storage = firebase.storage();
const googleProvider = new firebase.auth.GoogleAuthProvider();
const facebookProvider = new firebase.auth.FacebookAuthProvider();
const twitterProvider = new firebase.auth.TwitterAuthProvider();
const auth = firebase.auth();
export { db, storage, auth, googleProvider, facebookProvider, twitterProvider };
export default firebase;
